import { z } from 'zod';
/**
 * Wire primitives — reusable zod pieces for the shape data takes *after* JSON serialisation.
 *
 * Contracts describe the wire, not the API's internal domain types. A `Date` becomes an ISO
 * string and a decimal becomes a fixed-precision string once `res.json(...)` runs, so contracts
 * use these primitives and the API maps its domain objects to them at the route boundary — which
 * is exactly where a shape mismatch should be caught.
 */
/** UUID identifier. */
export const uuid = z.string().uuid();
/** ISO-8601 date-time string (a `Date` serialised over the wire). */
export const isoDateTime = z.string().datetime();
/** Calendar date with no time component, `YYYY-MM-DD`. */
export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected a YYYY-MM-DD date.');
/**
 * A money/rate value serialised as a fixed-precision decimal string — never a JS number.
 * Floating-point cannot represent money exactly; keeping it a string end to end means the
 * value that left the database is the value the browser renders.
 */
export const decimalString = z.string();
//# sourceMappingURL=wire.js.map